import React from 'react';

function BruntPlug() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_254_1577)">
        <g filter="url(#filter0_d_254_1577)">
          <path
            d="M71.2 16H8.8C6.14903 16 4 18.149 4 20.8V59.2C4 61.851 6.14903 64 8.8 64H71.2C73.851 64 76 61.851 76 59.2V20.8C76 18.149 73.851 16 71.2 16Z"
            fill="#E0DDDA"
          />
          <path
            d="M71.2004 64.7679H8.80042C5.73042 64.7679 3.23242 62.2699 3.23242 59.1999V20.7999C3.23242 17.7299 5.73042 15.2319 8.80042 15.2319H71.2004C74.2704 15.2319 76.7684 17.7299 76.7684 20.7999V59.1999C76.7684 62.2699 74.2704 64.7679 71.2004 64.7679ZM8.80042 16.7679C6.57842 16.7679 4.76842 18.5759 4.76842 20.7999V59.1999C4.76842 61.4219 6.57642 63.2319 8.80042 63.2319H71.2004C73.4224 63.2319 75.2324 61.4239 75.2324 59.1999V20.7999C75.2324 18.5779 73.4244 16.7679 71.2004 16.7679H8.80042Z"
            fill="#84827E"
          />
          <path
            d="M70.7992 19H9.19922C8.09465 19 7.19922 19.8954 7.19922 21V59C7.19922 60.1046 8.09465 61 9.19922 61H70.7992C71.9038 61 72.7992 60.1046 72.7992 59V21C72.7992 19.8954 71.9038 19 70.7992 19Z"
            fill="#F7F4F1"
          />
          <path
            d="M70.7995 61.7641H9.19955C7.67555 61.7641 6.43555 60.5241 6.43555 59.0001V21.0001C6.43555 19.4761 7.67555 18.2361 9.19955 18.2361H70.7995C72.3235 18.2361 73.5635 19.4761 73.5635 21.0001V59.0001C73.5635 60.5241 72.3235 61.7641 70.7995 61.7641ZM9.19955 19.7641C8.51755 19.7641 7.96355 20.3181 7.96355 21.0001V59.0001C7.96355 59.6821 8.51755 60.2361 9.19955 60.2361H70.7995C71.4815 60.2361 72.0355 59.6821 72.0355 59.0001V21.0001C72.0355 20.3181 71.4815 19.7641 70.7995 19.7641H9.19955Z"
            fill="#84827E"
          />
          <path
            d="M40.5239 39.918L40.3539 39.856L40.5179 39.778C41.0339 39.534 41.2739 39.152 41.2739 38.574C41.2739 37.706 40.4659 37 39.4739 37H36.9219V42.934H39.5479C40.5979 42.934 41.4499 42.19 41.4499 41.276C41.4499 40.624 41.1119 40.13 40.5239 39.918ZM37.8719 37.9H39.5499C39.9899 37.9 40.3079 38.22 40.3079 38.662C40.3079 39.104 39.9959 39.426 39.5499 39.426H37.8719V37.9ZM39.6219 42.022H37.8719V40.326H39.6219C40.1179 40.326 40.4779 40.684 40.4779 41.176C40.4779 41.668 40.1179 42.022 39.6219 42.022Z"
            fill="#83827F"
          />
          <path
            d="M47.5117 38.788C47.5117 37.786 46.6677 37 45.5917 37H42.9697V42.934H43.9257V40.644H45.4977L45.5177 40.69L46.4297 42.932H47.4857L46.4357 40.37L46.4977 40.338C47.1217 40.028 47.5097 39.434 47.5097 38.786L47.5117 38.788ZM45.6517 39.73H43.9357V37.904H45.6517C46.1737 37.904 46.5537 38.288 46.5537 38.818C46.5537 39.348 46.1737 39.73 45.6517 39.73Z"
            fill="#83827F"
          />
          <path
            d="M52.5122 41.26C52.5122 41.73 52.1382 42.082 51.6402 42.082H50.8082C50.3022 42.082 49.9042 41.72 49.9042 41.26V37H48.9102V41.298C48.9102 42.236 49.7622 43 50.8082 43H51.6402C52.6882 43 53.5402 42.236 53.5402 41.298V37H52.5122V41.26Z"
            fill="#83827F"
          />
          <path
            d="M58.6863 41.404L56.2103 37H55.0703V42.934H56.0643V38.52L58.5603 42.934H59.6983V37H58.6863V41.404Z"
            fill="#83827F"
          />
          <path
            d="M60.9717 37.906H62.5777V42.934H63.5897V37.906H65.1997V37H60.9717V37.906Z"
            fill="#83827F"
          />
          <path
            d="M18.4 43.4001C20.2778 43.4001 21.8 41.8779 21.8 40.0001C21.8 38.1223 20.2778 36.6001 18.4 36.6001C16.5222 36.6001 15 38.1223 15 40.0001C15 41.8779 16.5222 43.4001 18.4 43.4001Z"
            fill="url(#paint0_linear_254_1577)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_254_1577"
          x="1.83242"
          y="13.8319"
          width="79.5361"
          height="55.5359"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_254_1577"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_254_1577"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_254_1577"
          x1="15.9564"
          y1="37.2083"
          x2="20.5723"
          y2="42.503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <clipPath id="clip0_254_1577">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BruntPlug;
